import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "py-2 py-lg-4" };
const _hoisted_2 = { class: "d-flex gap-20 justify-content-between align-items-center mb-12 text-gray-600" };
const _hoisted_3 = { class: "d-flex gap-20 align-items-center" };
const _hoisted_4 = { class: "c-qa-avatar rounded-pill overflow-hidden" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "d-md-flex gap-20 align-items-center text-nowrap" };
const _hoisted_7 = { class: "opacity-50" };
const _hoisted_8 = { class: "d-flex align-items-center" };
const _hoisted_9 = ["data-rated", "data-id"];
const _hoisted_10 = { class: "text-primary mb-1" };
const _hoisted_11 = { class: "h5 mb-1" };
const _hoisted_12 = { class: "mb-12" };
const _hoisted_13 = { class: "text-end" };
const _hoisted_14 = ["href", "aria-controls"];
const _hoisted_15 = {
    key: 0,
    class: "mt-4 py-2 py-lg-4 ps-4 ps-xl-60"
};
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center mb-12 text-gray-600" };
const _hoisted_17 = { class: "d-flex gap-20 align-items-center" };
const _hoisted_18 = { class: "c-qa-avatar rounded-pill overflow-hidden" };
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = { key: 0 };
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = ["id"];
const _hoisted_23 = { class: "pt-3 pt-lg-5 pb-2 pb-lg-4 ps-4 ps-xl-60" };
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center mb-12 text-gray-600" };
const _hoisted_25 = { class: "d-flex gap-20 align-items-center" };
const _hoisted_26 = { class: "c-qa-avatar rounded-pill overflow-hidden" };
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = { class: "d-flex gap-12 justify-content-end mt-12" };
const _hoisted_29 = ["href", "aria-controls"];
const _hoisted_30 = ["disabled"];
import ReplyItem from '@vue/components/comment/ReplyItem.vue';
import { DateTime } from 'ts-luxon';
import { onMounted, ref, watch } from 'vue';
import DOMPurify from 'dompurify';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CommentItem',
    props: {
        comment: {},
        replies: {}
    },
    emits: ['edit'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const user = u.data('user');
        const lessonSectionOrder = u.data('lessonSectionOrder');
        const subReplies = ref(props.replies[props.comment.id] ?? []);
        const replyCount = ref(subReplies.value.length ?? 0);
        const sectionTitle = ref('');
        const favoriteBtn = ref();
        const ratingCount = ref();
        const replyCollapse = ref();
        const editingReply = ref({
            content: '',
            parent_id: props.comment.id,
            id: null
        });
        const loading = ref(false);
        const date = DateTime.fromISO(props.comment.created, { zone: 'UTC' })
            .setZone('Asia/Taipei')
            .toFormat('yyyy-MM-dd');
        function prepareSectionTitle() {
            lessonSectionOrder.forEach((chapter, i) => {
                chapter.forEach((section, j) => {
                    if (section.id === props.comment.targetId) {
                        sectionTitle.value = `第 ${i + 1} 章．第 ${j + 1} 節`;
                    }
                });
            });
        }
        async function prepareCommentRatingCount(commentId) {
            const res = await u.$http.get('@ajax_lesson/prepareCommentRatingCount', {
                params: {
                    comment_id: commentId,
                }
            });
            const count = res.data.data;
            if (ratingCount.value) {
                ratingCount.value.innerHTML = count;
            }
        }
        function editComment() {
            emits('edit', props.comment);
        }
        async function editReply(content, v) {
            try {
                await u.$http.post('@ajax_lesson/addOrEditReply', {
                    content: content,
                    id: v.id,
                    parent_id: v.parentId,
                });
                subReplies.value = subReplies.value.map((reply) => {
                    if (reply.id === v.id) {
                        return { ...reply, content: content };
                    }
                    else {
                        return reply;
                    }
                });
            }
            catch (e) {
                swal(e.message);
            }
        }
        async function addReply() {
            try {
                loading.value = true;
                const res = await u.$http.post('@ajax_lesson/addOrEditReply', {
                    content: editingReply.value.content,
                    parent_id: editingReply.value.parent_id,
                });
                editingReply.value.content = '';
                subReplies.value.push(res.data.data);
                replyCollapse.value?.classList.remove('show');
            }
            catch (e) {
                swal(e.message);
            }
            finally {
                loading.value = false;
            }
        }
        async function deleteReply(v) {
            const res = await u.$http.post('@ajax_lesson/deleteReply', {
                id: v.id,
            });
            if (res.data.data) {
                subReplies.value = subReplies.value.filter((reply) => {
                    return reply.id !== v.id;
                });
            }
        }
        function prepareReply(reply) {
            const raw = reply?.replace(/\n/g, '<br>') ?? '';
            return DOMPurify.sanitize(raw);
        }
        watch(props.comment, () => {
            prepareSectionTitle();
        });
        onMounted(() => {
            prepareSectionTitle();
            favoriteBtn.value?.addEventListener('rated', async (e) => {
                const target = e.target;
                const id = target.dataset.id ?? '0';
                await prepareCommentRatingCount(id);
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("img", {
                                        src: _ctx.comment?.user.avatar ? _ctx.comment.user.avatar : 'assets/images/front/demo/avatar.svg',
                                        alt: _ctx.comment.user.nickname !== '' ? _ctx.comment.user.nickname : '匿名',
                                        class: "w-100 h-100 object-fit-cover"
                                    }, null, 8, _hoisted_5)
                                ]),
                                _createTextVNode(" " + _toDisplayString(_ctx.comment.user.nickname !== '' ? _ctx.comment.user.nickname : '匿名') + " ", 1),
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-none d-md-inline" }, "|", -1)),
                                _cache[2] || (_cache[2] = _createElementVNode("br", { class: "d-md-none" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa-solid fa-comment me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(replyCount.value) + "則 ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("a", {
                                        href: "javascript://",
                                        ref_key: "favoriteBtn",
                                        ref: favoriteBtn,
                                        class: "j-qa-favicon c-qa-favicon btn me-2 p-0",
                                        "uni-rating-button": "",
                                        "data-rated": _ctx.comment.rated,
                                        "data-type": "comment",
                                        "data-id": _ctx.comment.id,
                                        "data-class-active": "",
                                        "data-class-inactive": "",
                                        "data-icon-active": "fas fa-heart",
                                        "data-icon-inactive": "far fa-heart",
                                        "data-title-active": "取消",
                                        "data-title-inactive": "讚"
                                    }, _cache[4] || (_cache[4] = [
                                        _createElementVNode("i", null, null, -1)
                                    ]), 8, _hoisted_9),
                                    _createElementVNode("span", {
                                        class: "opacity-50",
                                        ref_key: "ratingCount",
                                        ref: ratingCount
                                    }, _toDisplayString(_ctx.comment.rating_count), 513)
                                ]),
                                (_unref(user).id === _ctx.comment.userId)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: "javascript://",
                                        class: "link-gray-600",
                                        onClick: editComment
                                    }, " 編輯 "))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(sectionTitle.value), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.comment.title), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.comment.content), 1),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("a", {
                                class: "fz-s",
                                "data-bs-toggle": "collapse",
                                href: '#collapseComment-' + _ctx.comment.id,
                                role: "button",
                                "aria-expanded": "false",
                                "aria-controls": 'collapseComment-' + _ctx.comment.id
                            }, " 回覆 ", 8, _hoisted_14)
                        ])
                    ]),
                    (_ctx.comment.params?.['reply'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("img", {
                                            src: _ctx.comment.reply_teacher?.avatar ? _ctx.comment.reply_teacher?.avatar : 'assets/images/front/demo/avatar.svg',
                                            alt: (_ctx.comment.reply_teacher?.nickname !== '' ? _ctx.comment.reply_teacher?.nickname : '匿名') + '老師',
                                            class: "w-100 h-100 object-fit-cover"
                                        }, null, 8, _hoisted_19)
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.comment.reply_teacher?.nickname !== '' ? _ctx.comment.reply_teacher?.nickname : '匿名') + "老師 ", 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "d-none d-md-inline" }, "|", -1)),
                                    _cache[6] || (_cache[6] = _createElementVNode("br", { class: "d-md-none" }, null, -1)),
                                    (_ctx.comment.params?.['reply_at'])
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(DateTime).fromSQL(_ctx.comment.params?.['reply_at'], { zone: 'UTC' }).setZone('Asia/Taipei').toFormat('yyyy-MM-dd')), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "mb-0",
                                innerHTML: prepareReply(_ctx.comment.params?.['reply'])
                            }, null, 8, _hoisted_21)
                        ]))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subReplies.value, (item) => {
                        return (_openBlock(), _createBlock(ReplyItem, {
                            key: item.id,
                            reply: item,
                            onEdit: editReply,
                            onDelete: deleteReply
                        }, null, 8, ["reply"]));
                    }), 128)),
                    _createElementVNode("div", {
                        class: "collapse",
                        id: 'collapseComment-' + _ctx.comment.id,
                        ref_key: "replyCollapse",
                        ref: replyCollapse
                    }, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("img", {
                                            src: _unref(user)?.avatar ? _unref(user).avatar : 'assets/images/front/demo/avatar.svg',
                                            alt: _unref(user).nickname !== '' ? _unref(user).nickname : '匿名',
                                            class: "w-100 h-100 object-fit-cover"
                                        }, null, 8, _hoisted_27)
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(_unref(user).nickname !== '' ? _unref(user).nickname : '匿名') + " ", 1),
                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "d-none d-md-inline" }, "|", -1)),
                                    _cache[8] || (_cache[8] = _createElementVNode("br", { class: "d-md-none" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(DateTime).now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd')), 1)
                                ])
                            ]),
                            _createElementVNode("div", null, [
                                _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control",
                                    placeholder: "輸入提問內容",
                                    rows: "3",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editingReply.value.content) = $event))
                                }, null, 512), [
                                    [_vModelText, editingReply.value.content]
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("a", {
                                        class: _normalizeClass(["btn btn-outline-primary btn-sm", { 'disabled': loading.value }]),
                                        "data-bs-toggle": "collapse",
                                        href: '#collapseComment-' + _ctx.comment.id,
                                        role: "button",
                                        "aria-expanded": "false",
                                        "aria-controls": '#collapseComment-' + _ctx.comment.id
                                    }, " 取消 ", 10, _hoisted_29),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary btn-sm",
                                        onClick: addReply,
                                        disabled: loading.value
                                    }, " 送出 ", 8, _hoisted_30)
                                ])
                            ])
                        ])
                    ], 8, _hoisted_22)
                ])
            ]));
        };
    }
});
